// extracted by mini-css-extract-plugin
module.exports = {"anchor":"ChunkCard__anchor--3me1m","bounce":"ChunkCard__bounce--3r4mJ"};